export const environment = {
    production: false,
    serverUrl: 'https://6lv3v319hf.execute-api.us-east-2.amazonaws.com/dev',
    bucket: 'kcasenterprise-prod-upload',
    userPool: {
      UserPoolId: 'us-east-2_ZmWSFBMRy',
      ClientId: '2sp7s3veb0qfur579n76l6ruiv',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:5e2d2622-0257-45d0-8f35-73e17ef41d07',
    buckets: {
      'us-east-2': 'kcasenterprise-prod-upload'
    },
    modules: {
      key: 'analysisType',
      values: [
          {
            'name': 'qPCR',
            'desc': 'qPCR'
          },
          {
            'name': 'AP',
            'desc': 'A&P Regression'
          }
      ]
  },
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId: 'us-east-2:5e2d2622-0257-45d0-8f35-73e17ef41d07', // REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_ZmWSFBMRy', // OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '2sp7s3veb0qfur579n76l6ruiv', // OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'kcasenterprise-prod-upload',
        region: 'us-east-2', // OPTIONAL -  Amazon service region
      }
    }
  };
  const awsconfig = {
    'aws_project_region': 'us-east-2',
    'aws_cognito_region': 'us-east-2',
    'aws_user_pools_id': 'us-east-2_ZmWSFBMRy',
    'aws_user_pools_web_client_id': '2sp7s3veb0qfur579n76l6ruiv',
    'aws_cognito_mfa_configuration': 'OPTIONAL',

  };
  export default awsconfig;